import { render } from "./OrderDataBarChart.vue?vue&type=template&id=1b709c2e&scoped=true&ts=true"
import script from "./OrderDataBarChart.vue?vue&type=script&lang=ts"
export * from "./OrderDataBarChart.vue?vue&type=script&lang=ts"

import "./OrderDataBarChart.vue?vue&type=style&index=0&id=1b709c2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b709c2e"]])

export default __exports__